const enums = {
    theme: {
        Light: {
            id: 1,
            label: 'Light'
        },
        Dark: {
            id: 2,
            label: 'Dark'
        }
    },
    courseLevel: {
        Beginner: {
            id: 1,
            label: "Beginner"
        },
        Intermediate: {
            id: 2,
            label: "Intermediate"
        },
        Advanced: {
            id: 3,
            label: "Advanced"
        },
    },
    videoCardSize: {
        Xsmall: {
            id: 1,
            label: "xsmall"
        },
        Small: {
            id: 2,
            label: "small"
        },
        Medium: {
            id: 3,
            label: "medium"
        },
        Large: {
            id: 4,
            label: "large"
        },
    },
    videoType: {
        TechByte: {
            id: 1,
            label: "TechByte"
        },
        LearningVideo: {
            id: 2,
            label: "Learning Video"
        },
        CourseEpisode: {
            id: 3,
            label: "Course Episode"
        }
    },
    userType: {
        Learner: {
            id: 1,
            label: 'Learner'
        },
        LearningEnabler: {
            id: 2,
            label: 'Learning-Enabler'
        }
    }
}

Object.freeze(enums);
export default enums;